var React = require('react');

function PurpleTickInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"data-name":"Icon material-done","d":"m9.7 17.1-3.451-3.446L5.1 14.8l4.6 4.6 9.851-9.851L18.4 8.4z","transform":"translate(-5.1 -8.4)","style":{"fill":"#9c6af9"}}));
}

PurpleTickInline.defaultProps = {"width":"14.448","height":"11","viewBox":"0 0 14.448 11"};

module.exports = PurpleTickInline;

PurpleTickInline.default = PurpleTickInline;
